module.exports = __webpack_public_path__ + "img/lotto.4d70cf8d.png";